import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

import videojs from 'video.js';
import 'video.js/dist/video-js.css';

import InfoDrawer	from '../common/_InfoDrawer.jsx';
import moment 		from 'moment';

import DownloadNav from './_DownloadNav.jsx';
import StudioMoreInformation from './_StudioMoreInformation.jsx';
import StudioDownloadHeader from './_StudioDownloadHeader.jsx';


import {Hinge, Instructions, Render} from './_StudioIcons.jsx';

import blAjax					from '../utils/_ajax.jsx'; 

const mac_dl_link 		= ("https://studio.download.bricklink.info/Studio2.0/Studio+2.0.pkg");
const win_dl_link_32bit = ("https://studio.download.bricklink.info/Studio2.0/Studio+2.0_32.exe");
const win_dl_link_64bit = ("https://studio.download.bricklink.info/Studio2.0/Studio+2.0.exe");

export default class StudioDownload extends BLComponent {
	constructor (props) {
		super(props);

		this.state = {
			featureView: 0,
			changeLog: blapp.models.get('changeLog'),
			latestLogVersion: blapp.models.get('changeLog').reverse()[0].strVersion,
			os: this.getClientOS(),
			version: this.getClientVersion(),
		};
	}

	componentDidMount() {
		this.setState({selectedLogVersion: this.state.latestLogVersion});
		
		//track visit
		blapp.track.trackGeneral(13, document.referrer);

		const aoc = blapp.util.getUrlVars().aoc;

		if((typeof aoc !== "undefined") && (aoc.trim() !== "")) {
			this.trackAdCode(aoc);
		}

		window.addEventListener('scroll', () => {
			if(window.scrollY - this.quickNavMenu.offsetHeight >= this.quickNavStart.offsetTop) {
				if(!this.quickNavMenu.classList.contains('studio-download__quick-nav-container--fixed')) {
					this.quickNavMenu.classList.add('studio-download__quick-nav-container--fixed');				
				}
			}else{
				if(this.quickNavMenu.classList.contains('studio-download__quick-nav-container--fixed')) {
					this.quickNavMenu.classList.remove('studio-download__quick-nav-container--fixed');		
				}		
			}

			this.highlightNavItem();
		});
		
		const stackHingePlayerProps = {
			autoplay: true,
			playsinline: true,
			muted: true,
			controls: true,
			loop: true,
			controlBar: {
					'pictureInPictureToggle': false,
					'volumePanel': false,
					'fullscreenToggle': false
			},
			aspectRatio: '25:19',
			sources: [{
				src: '//cache2.bricklink.info/img/studio-download/stack-and-hinge.mp4',
				type: 'video/mp4'
			}]
		};

		const instructionMakerPlayerProps = {
			autoplay: true,
			playsinline: true,
			muted: true,
			controls: true,
			loop: true,
			controlBar: {
					'pictureInPictureToggle': false,
					'volumePanel': false,
					'fullscreenToggle': false
			},
			aspectRatio: '25:19',
			sources: [{
				src: '//cache2.bricklink.info/img/studio-download/instruction-maker.mp4',
				type: 'video/mp4'
			}]
		};

		const renderingPlayerProps = {
			autoplay: true,
			playsinline: true,
			muted: true,
			controls: true,
			loop: true,
			controlBar: {
					'pictureInPictureToggle': false,
					'volumePanel': false,
					'fullscreenToggle': false
			},
			aspectRatio: '25:19',
			sources: [{
				src: '//cache2.bricklink.info/img/studio-download/renderer.mp4',
				type: 'video/mp4'
			}]
		};

    this.stackHingePlayer = videojs(this.stackHingeNode, stackHingePlayerProps, () => {});
		this.instructionMakerPlayer = videojs(this.instructionMakerNode, instructionMakerPlayerProps, () => {});
		this.renderingPlayer = videojs(this.renderingNode, renderingPlayerProps, () => {});
	}

	highlightNavItem() {
		const sectionPositions = [
			{section: 'keyFeatures', offset: document.getElementById('keyFeatures').offsetTop},
			{section: 'specs', offset: document.getElementById('specs').offsetTop},
			{section: 'changelog', offset: document.getElementById('changelog').offsetTop},
			{section: 'realize', offset: document.getElementById('realize').offsetTop},
			{section: 'learn', offset: document.getElementById('learn').offsetTop},
			{section: 'advance', offset: document.getElementById('advance').offsetTop}
		].reverse();

		const activeScrollPosition = sectionPositions.filter(item => item.offset - 2 < window.scrollY)[0];

		if(activeScrollPosition) {
			if(this.state.quickNavSection != activeScrollPosition.section) {
				this.setState({quickNavSection: activeScrollPosition.section});
			}
		}else{
			this.setState({quickNavSection: ''});
		}
	}

	render() {
		return (
			<React.Fragment>
				<DownloadNav page={1}/>
				<StudioDownloadHeader>{this.renderDownloadButton()}</StudioDownloadHeader>
				<div className="studio-download__main">
					{this.renderInternalNav()}
					{this.renderFeatures()}
					{this.renderSpecs()}
					{this.renderChangeLog()}
					{this.renderRealize()}
					{this.renderLearn()}
					{this.renderAdvance()}
					{this.renderFooter()}
				</div>
			</React.Fragment>
		);
	}

	renderInternalNav() {
		return (
			<React.Fragment>
				<div ref={quickNavStart => this.quickNavStart = quickNavStart}></div>
				<section ref={quickNavMenu => this.quickNavMenu = quickNavMenu} className="studio-download__quick-nav-container">
					<ul className="studio-download__quick-nav">
						<li className="studio-download__quick-nav-item"><a href="#keyFeatures" onClick={(e) => this.quickNav(e, 'keyFeatures')} className={`studio-download__quick-nav-link ${this.state.quickNavSection == 'keyFeatures' ? 'studio-download__quick-nav-link--active' : ''}`}>Key Features</a></li>
						<li className="studio-download__quick-nav-item"><a href="#specs" onClick={(e) => this.quickNav(e, 'specs')} className={`studio-download__quick-nav-link ${this.state.quickNavSection == 'specs' ? 'studio-download__quick-nav-link--active' : ''}`}>Specs</a></li>
						<li className="studio-download__quick-nav-item"><a href="#changelog" onClick={(e) => this.quickNav(e, 'changelog')} className={`studio-download__quick-nav-link ${this.state.quickNavSection == 'changelog' ? 'studio-download__quick-nav-link--active' : ''}`}>Changelog</a></li>
						<li className="studio-download__quick-nav-item"><a href="#realize" onClick={(e) => this.quickNav(e, 'realize')} className={`studio-download__quick-nav-link ${this.state.quickNavSection == 'realize' ? 'studio-download__quick-nav-link--active' : ''}`}>Realize</a></li>
						<li className="studio-download__quick-nav-item"><a href="#learn" onClick={(e) => this.quickNav(e, 'learn')} className={`studio-download__quick-nav-link ${this.state.quickNavSection == 'learn' ? 'studio-download__quick-nav-link--active' : ''}`}>Learn</a></li>
						<li className="studio-download__quick-nav-item"><a href="#advance" onClick={(e) => this.quickNav(e, 'advance')} className={`studio-download__quick-nav-link ${this.state.quickNavSection == 'advance' ? 'studio-download__quick-nav-link--active' : ''}`}>Advance</a></li>
					</ul>
				</section>
			</React.Fragment>
		);
	}

	quickNav(e, section) {
		e.preventDefault();

		if(section == 'changelog') {
			this.setState({showChangeLog: true});
		}

		const sectionTop = document.querySelector(`#${section}`).offsetTop;
		window.scrollTo({top: sectionTop, left:0, behavior: 'smooth'});
	}

	renderFeatures() {
		return (
			<section id="keyFeatures" className="container studio-download__features-container studio-download__features-container--tight-mob">
				<div className="container__internal l-pad-x">
					<div className="studio-download__features-intro text--center">
						<h1 className="studio-download__section-title">Digitally build designs of your wildest imagination</h1>
						<p className="text--xl-title text-color--secondary">Unlimited bricks give you total freedom to create. BrickLink integration lets you share your work and purchase elements to build for real.</p>
					</div>
					<article className="studio-download__features-item">
						<div className="studio-download__features-item-image l-border-round overflow-hidden">
							<div data-vjs-player>
								<video ref={node => this.stackHingeNode = node} className="video-js"></video>
							</div>
						</div>
						<div className="studio-download__features-item-content">
							<Hinge classes="studio-download__features-item-icon"/>
							<h1 className="studio-download__features-item-title text--xl-title text--bold">Intuitive and easy building</h1>
							<p className="studio-download__features-item-text text--title text-color--secondary">Stack, clutch, hinge, and clip parts together effortlessly using snap-to functionality that lets you quickly build digital creations.</p>
						</div>
					</article>
					<article className="studio-download__features-item">
						<div className="studio-download__features-item-content">
							<Instructions classes="studio-download__features-item-icon"/>
							<h1 className="studio-download__features-item-title text--xl-title text--bold">Instruction Maker</h1>
							<p className="studio-download__features-item-text text--title text-color--secondary">Create custom, print-ready instructions using the in-app instructions maker. Edit steps and design pages all within Studio.</p>
						</div>
						<div className="studio-download__features-item-image l-border-round overflow-hidden">
							<div data-vjs-player>
								<video ref={node => this.instructionMakerNode = node} className="video-js"></video>
							</div>
						</div>
					</article>
					<article className="studio-download__features-item studio-download__features-item--last">
					<div className="studio-download__features-item-image l-border-round overflow-hidden">
							<div data-vjs-player>
								<video ref={node => this.renderingNode = node} className="video-js"></video>
							</div>
						</div>
						<div className="studio-download__features-item-content">
							<Render classes="studio-download__features-item-icon"/>
							<h1 className="studio-download__features-item-title text--xl-title text--bold">Photorealistic Renderer</h1>
							<p className="studio-download__features-item-text text--title text-color--secondary">Render and export breathtaking, exceptional quality images for your creations, and create gorgeous building sequence videos to show off your designs! This software uses code of <a href="http://ffmpeg.org" target="_blank">FFmpeg</a> licensed under the <a href="http://www.gnu.org/licenses/old-licenses/lgpl-2.1.html" target="_blank">LGPLv2.1</a> and its source can be downloaded <a href="https://studio.download.bricklink.info/Studio2.0/ExternalLibrary/ffmpeg-4.0.2.zip" target="_blank">here</a>.</p>
						</div>
					</article>
					<div className="text--center l-margin-bottom--l">
						<h1 className="studio-download__section-title">LEGO artwork from images</h1>
						<p className="text--xl-title text-color--secondary">Personalize and customize your creations so they’re as unique as you are!</p>
					</div>
					<div className="studio-download__card-container">
						<article className="simple-image-text-card">
							<a href="https://studiohelp.bricklink.com/hc/en-us/articles/15341721435799-Reference-Image" className="simple-image-text-card__image">
								<img className="l-full-width l-block" src={`//${blapp.config.getHost("static2")}/img/studio-download/reference-image.png`} alt="A lighthouse being used as a reference for a lighthouse MOC"/>
							</a>
							<div className="simple-image-text-card__text text--small-title">
								<h1 className="text--title text--bold l-margin-bottom--md">Reference Image</h1>
								<p className="text-color--secondary l-margin-bottom">Insert an image as a guide to create more detailed designs.</p>
								<a className="simple-image-text-card__cta text--bold" href="https://studiohelp.bricklink.com/hc/en-us/articles/15341721435799-Reference-Image" target="_blank">Learn how<i className="far fa-external-link-square-alt l-margin-left--sm"/></a>
							</div>
						</article>
						<article className="simple-image-text-card">
							<a href="https://studiohelp.bricklink.com/hc/en-us/articles/6508264220183-Sculpture" className="simple-image-text-card__image">
								<img className="l-full-width l-block" src={`//${blapp.config.getHost("static2")}/img/studio-download/3d-sculpture.png`} alt="An image referencing the outcome of a LEGO sculpture from a 3d file import"/>
							</a>
							<div className="simple-image-text-card__text text--small-title">
								<h1 className="text--title text--bold l-margin-bottom--md">3D Sculpture</h1>
								<p className="text-color--secondary l-margin-bottom">Magically transform a 3D file into a 3D LEGO sculpture.</p>
								<a className="simple-image-text-card__cta text--bold" href="https://studiohelp.bricklink.com/hc/en-us/articles/6508264220183-Sculpture" target="_blank">Learn how<i className="far fa-external-link-square-alt l-margin-left--sm"/></a>
							</div>
						</article>
						<article className="simple-image-text-card">
							<a href="https://studiohelp.bricklink.com/hc/en-us/articles/5625025298327-Mosaic" className="simple-image-text-card__image">
								<img className="l-full-width l-block" src={`//${blapp.config.getHost("static2")}/img/studio-download/mosaic-maker.png`} alt="A spaceman minifigure being turned into a mosaic"/>
							</a>
							<div className="simple-image-text-card__text text--small-title">
								<h1 className="text--title text--bold l-margin-bottom--md">Mosaic Maker Image</h1>
								<p className="text-color--secondary l-margin-bottom">Import a photo and create a custom LEGO mosaic.</p>
								<a className="simple-image-text-card__cta text--bold" href="https://studiohelp.bricklink.com/hc/en-us/articles/5625025298327-Mosaic" target="_blank">Learn how<i className="far fa-external-link-square-alt l-margin-left--sm"/></a>
							</div>
						</article>
					</div>
				</div>
			</section>
		);
	}

	renderSpecs() {		
		return (
			<section id="specs" className="container studio-download__specs">
				<div className="container__internal l-pad-x">
					<div className="studio-download__specs-header">
						<h1 className="studio-download__section-title text--inherit">Download Studio today!</h1>
						{this.renderDownloadButton('simple')}
					</div>
					<h2 className="studio-download__specs-sub-title">Minimum Specifications</h2>
					<ul className="studio-download__specs-items">
						<li className="studio-download__specs-item">
							<div className="l-flex l-center l-margin-bottom text--uppercase text--bold text--small"><i className="text--small-title fas fa-desktop l-margin-right--sm"/>Operating System</div>
							<p className="text--small-title">64 or 32-bit Windows 7 SP1+, macOS 10.13 or newer</p>
						</li>
						<li className="studio-download__specs-item">
							<div className="l-flex l-center l-margin-bottom text--uppercase text--bold text--small"><i className="text--small-title fas fa-image l-margin-right--sm"/>GPU</div>
							<p className="text--small-title">Graphic card with DX9 (shader model 2.0) capabilities. Studio only supports Nvidia graphics cards at this moment.</p>
						</li>
						<li className="studio-download__specs-item">
							<div className="l-flex l-center l-margin-bottom text--uppercase text--bold text--small"><i className="text--small-title fas fa-ram l-margin-right--sm"/>RAM</div>
							<p className="text--small-title">1GB RAM</p>
						</li>
						<li className="studio-download__specs-item">
							<div className="l-flex l-center l-margin-bottom text--uppercase text--bold text--small"><i className="text--small-title fas fa-hard-drive l-margin-right--sm"/>Storage</div>
							<p className="text--small-title">2GB available space</p>
						</li>
					</ul>
				</div>
			</section>
		);
	}

	renderChangeLog() {
		let versions = {}
		const selectedLogVersion = this.state.selectedLogVersion;
		const logType = this.state.changeLog;

		logType.forEach( entry =>{
			if(versions[entry.patchYear] == null || versions[entry.patchYear] == 'undefined'){
				versions[entry.patchYear] = [{month: moment(entry.patchMonth,'MM').format('MMMM'), day: entry.patchDay, year: entry.patchYear, version: entry.strVersion}]
			}else{
				versions[entry.patchYear].push({month: moment(entry.patchMonth,'MM').format('MMMM'), day: entry.patchDay, year: entry.patchYear, version: entry.strVersion})
			}
		});

		const options = Object.keys(versions).reverse().map((key) => {
			const patches = versions[key];
			return (
				<optgroup label={parseInt(key) + 2000} key={key}>
					{patches.map(patch => <option key={patch.version} value={patch.version}>{patch.month} {patch.day}, 20{patch.year}</option>)}
				</optgroup>
			);
		});

		return (
			<section id="changelog" className="container studio-download__changelog-container">
				<div className="container__internal l-pad-x">
					<InfoDrawer classes="l-margin-bottom--xs studio-download__changelog-drawer" icon={"arrow"} position={"right"} bold={true} onChangeFunc={() => this.setState({showChangeLog: !this.state.showChangeLog})} isOpen={this.state.showChangeLog} label={"Changelog and older versions"}>
						<div className="studio-download__changelog-header">
							<h2 className="text--xl-title text--bold l-block">Version {selectedLogVersion}</h2>
							<div className="l-flex l-center studio-download__changelog-select">
								<label htmlFor="version-select" className="text--no-wrap">Version history:</label>
								<select id="version-select" className="select select--tight studio-download__changelog-select l-margin-left" onChange={(e) => this.showChangeLog(e)}>
									{options}
								</select>
							</div>
						</div>
						{this.renderChangeLogItem()}
					</InfoDrawer>
				</div>
			</section>
		);
	}

	renderChangeLogItem() {
		const logType 						= this.state.changeLog;
		const selectedLogVersion 	= this.state.selectedLogVersion;
		const latestLogVersion 		= this.state.latestLogVersion;

		const logIndex = logType.findIndex(entry => entry.strVersion == selectedLogVersion);
		const log = logType[logIndex];

		if(log != null) {
			return (
				<div className="studio-download__changelog">
					<div className="studio-download__changelog-sidebar">
						<strong className="l-block text--bold text--uppercase text-color--darkest48 text--small l-margin-bottom--xs">Release date</strong>
						<strong className="l-block text--bold text--small-title">{moment(log.patchMonth,'MM').format('MMM')} {log.patchDay}, {parseInt(log.patchYear)+2000}</strong>
						{latestLogVersion == selectedLogVersion ?
							<div className="pill pill--malechite72 l-border-round text--uppercase text--small text--bold l-pad-y--sm l-margin-top--xs">
								Latest version
							</div>
						: null}
						{this.renderDownloadInChangeLog()}
					</div>
					<div className="studio-download__changelog-content">
						{log && log.listBugFixes.length > 0 ?
						<div className="l-margin-bottom">
							<h3 className="l-block text--bold l-margin-bottom--sm">Bug fixes</h3>
							<ul className="bullet-list text-color--secondary">
								{log.listBugFixes.map((bug, idx) => <li key={idx}>{bug}</li>)}
							</ul>
						</div>
						: null}
						{log && log.listFeatures.length > 0 ?
						<div className="l-margin-bottom">
							<h3 className="l-block text--bold l-margin-bottom--sm">Features</h3>
							<ul className="bullet-list text-color--secondary">
								{log.listFeatures.map((feat, idx) => <li key={idx}>{feat}</li>)}
							</ul>
						</div>
						: null}
						{log && log.listImprovements.length > 0 ?
						<div>
							<h3 className="l-block text--bold l-margin-bottom--sm">Improvements</h3>
							<ul className="bullet-list text-color--secondary">
								{log.listImprovements.map((imp, idx) => <li key={idx}>{imp}</li>)}
							</ul>
						</div>
						: null}
					</div>
				</div>
			);
		}else{
			return null;
		}
	}

	showChangeLog(e) {
		this.setState({selectedLogVersion: e.target.value})
	}

	renderDownloadInChangeLog() {
		const logType 						= this.state.changeLog;
		const selectedLogVersion 	= this.state.selectedLogVersion;

		const selectedLogIndex 	= logType.findIndex(log => log.strVersion == selectedLogVersion);
		const selectedLog 			= logType[selectedLogIndex];
		const selectedFolder 		= `https://studio.download.bricklink.info/Studio2.0/Archive/${selectedLog.strVersion}`;

		return (
			<div className="studio-download__changelog-download">
				<strong className="text--bold text--uppercase text-color--darkest48 text--small l-margin-bottom--sm l-block">Download this version for</strong> 
				<ul>
					<li><a className="text--underline" target="_blank" onClick={()=>this.trackDownload(false, false)}  href={`${selectedFolder}/Studio+2.0.pkg`}>Mac</a></li>
					<li><a className="text--underline" target="_blank" onClick={()=>this.trackDownload(true, true)}  href={`${selectedFolder}/Studio+2.0_32.exe`}>Win 32bit</a></li>
					<li><a className="text--underline" target="_blank" onClick={() => this.trackDownload(true, false)} href={`${selectedFolder}/Studio+2.0.exe`}>Win 64bit</a></li>
				</ul>
			</div>
		)
	}

	renderRealize() {
		return (
			<section id="realize" className="container studio-download__realize">
				<div className="container__internal l-pad-x">
					<div className="text--center l-margin-bottom--xl">
						<h1 className="studio-download__section-title">Realize your MOCs and join the Studio community</h1>
						<p className="text--xl-title text-color--secondary">Buy parts to build your design in real life and share & promote your creations.</p>
					</div>
					<div className="studio-download__card-container">
						<article className="text--center l-full-width">
							<img className="studio-download__realize-image" src={`//${blapp.config.getHost("static2")}/img/studio-download/easy-buy.svg`} alt="Easy buy icon"/>
							<div className="text--small-title">
								<h1 className="text--title text--bold l-margin-bottom--md">Easy Buy and Wanted List</h1>
								<p className="text-color--secondary l-margin-bottom">Estimate the price of your creation as you build. When you’re finished, use Easy Buy or Wanted List to buy the parts.</p>
							</div>
						</article>
						<article className="text--center l-full-width">
							<img className="studio-download__realize-image" src={`//${blapp.config.getHost("static2")}/img/studio-download/share.svg`} alt="An upload icon"/>
							<div className="text--small-title">
								<h1 className="text--title text--bold l-margin-bottom--md">Share your designs</h1>
								<p className="text-color--secondary l-margin-bottom"><a href={blapp.url2.getStudioModelUploadUrl()}>Upload your designs</a> to the Studio Gallery and showcase your work with the community.</p>
							</div>
						</article>
						<article className="text--center l-full-width">
							<img className="studio-download__realize-image" src={`//${blapp.config.getHost("static2")}/img/studio-download/bdp.svg`} alt="A trophy icon"/>
							<div className="text--small-title">
								<h1 className="text--title text--bold l-margin-bottom--md">BrickLink Designer Program</h1>
								<p className="text-color--secondary l-margin-bottom">Enter your design to the <a href={blapp.url2.getCrowdProjectMainUrl()}>BrickLink Designer Program</a> for a chance to have it become an official BDP set! 5 finalists are chosen every BDP Series.</p>
							</div>
						</article>
					</div>
				</div>
			</section>
		);
	}

	renderLearn() {
		return (
			<section id="learn" className="container studio-download__learn">
				<div className="container__internal l-pad-x">
					<div className="studio-download__learn-header">
						<h1 className="studio-download__section-title">Beginners Start Here</h1>
						<a className="studio-download__learn-header-link text--small-title" href="https://studiohelp.bricklink.com/hc/en-us" target="_blank">See more Help articles<i className="far fa-external-link-square-alt l-margin-left--sm"/></a>
					</div>
					<div className="studio-download__card-container">
						<article className="simple-image-text-card l-full-width">
							<a href="https://studiohelp.bricklink.com/hc/en-us/categories/5404814688023-Getting-Started" className="simple-image-text-card__image">
								<img className="l-full-width l-block" src={`//${blapp.config.getHost("static2")}/img/studio-download/getting-started.png`} alt="BrickLink Studio Tutorial Introduction by Boone"/>
							</a>
							<div className="simple-image-text-card__text text--small-title">
								<h1 className="text--title text--bold l-margin-bottom--md">Getting started</h1>
								<p className="text-color--secondary l-margin-bottom">Boone gives an overview of BrickLink Studio for LEGO enthusiasts interested in getting into digital design or migrating from other digital building platforms such as LEGO Digital Designer.</p>
								<a className="simple-image-text-card__cta text--bold" href="https://studiohelp.bricklink.com/hc/en-us/categories/5404814688023-Getting-Started" target="_blank">Watch video<i className="far fa-external-link-square-alt l-margin-left--sm"/></a>
							</div>
						</article>
						<article className="simple-image-text-card l-full-width">
							<a href="https://studiohelp.bricklink.com/hc/en-us/articles/5404381697559-Introduction-to-Studio" className="simple-image-text-card__image">
								<img className="l-full-width l-block" src={`//${blapp.config.getHost("static2")}/img/studio-download/intro-to-studio.png`} alt="A screenshot of the BrickLink Studio app ui"/>
							</a>
							<div className="simple-image-text-card__text text--small-title">
								<h1 className="text--title text--bold l-margin-bottom--md">Introduction to Studio</h1>
								<p className="text-color--secondary l-margin-bottom">Studio is an all-in-one desktop app for Windows and Mac that lets you build with virtual LEGO® parts, render designs and create instructions.</p>
								<a className="simple-image-text-card__cta text--bold" href="https://studiohelp.bricklink.com/hc/en-us/articles/5404381697559-Introduction-to-Studio" target="_blank">Read article<i className="far fa-external-link-square-alt l-margin-left--sm"/></a>
							</div>
						</article>
					</div>
				</div>
			</section>
		);
	}

	renderAdvance() {
		return (
			<section id="advance" className="container studio-download__advanced">
				<div className="container__internal l-pad-x">
					<h1 className="text--title text--bold text--tight l-margin-bottom--l">For advanced builders</h1>
					<div className="studio-download__card-container">
						<article className="studio-download__cross-promo-card studio-download__cross-promo-card--top-left studio-download__cross-promo-card--orange">
							<div className="studio-download__cross-promo-card-internal">
								<div className="studio-download__cross-promo-icon-title">
									<img src={`//${blapp.config.getHost( "static2" )}/img/studio-download/early-access-large.svg`} alt="Early Access Logo"/>
									<h2 className="text--bold text--title">Studio Early Access</h2>
								</div>
								<p className="studio-download__cross-promo-content">Be the first to test out new features.</p>
								<a className="btn btn--wide studio-download__cross-promo-cta" href={blapp.url2.getEarlyAccessDownloadUrl()}>Learn more</a>
							</div>
						</article>
						<article className="studio-download__cross-promo-card studio-download__cross-promo-card--bottom-right studio-download__cross-promo-card--green">
							<div className="studio-download__cross-promo-card-internal">
								<div className="studio-download__cross-promo-icon-title">
									<img src={`//${blapp.config.getHost( "static2" )}/img/studio-download/part-designer-dark.svg`} alt="PartDesigner Logo"/>
									<h2 className="text--bold text--title">PartDesigner</h2>
								</div>
								<p className="studio-download__cross-promo-content">Design your own custom parts.</p>
								<a className="btn btn--wide studio-download__cross-promo-cta" href={blapp.url2.getPartDesignerDownloadUrl()}>Learn more</a>
							</div>
						</article>
					</div>
				</div>
			</section>
		);
	}

	renderFooter() {
		return (
			<section className="container studio-download__footer">
				<div className="container__internal l-pad-x">
					<StudioMoreInformation/>
				</div>
			</section>
		);
	}

	renderDownloadButton(type) {
		const isWindows = (this.state.os === 'Windows');
		const is32 			= (this.state.version === '32bit');

		const win_dl_32 = win_dl_link_32bit;
		const win_dl_64 = win_dl_link_64bit;
		const mac_dl 		= mac_dl_link;

		const downloadLink = isWindows ? (is32 ? win_dl_32 : win_dl_64) : mac_dl;

		const isMobile = blapp.md.tablet() || blapp.md.mobile() || blapp.md.phone();

		if(!isMobile) {
			return (
				<a href={downloadLink} onClick={() => this.trackDownload(isWindows, isWindows ? is32 : false)} className="studio-download__hero-cta">
					<i className="fas fa-download l-margin-right"/>Download {type == 'simple' ? '' : 'Studio'} for {isWindows ? 'Windows' : 'Mac'}
				</a>
			);
		}else{
			return (
				<div className="studio-download__hero-cta studio-download__hero-cta--mobile">
					<i className="fas fa-download l-margin-right"/>To download Studio, please use a desktop computer.
				</div>
			);
		}
	}

	getClientOS() {
		let OSName = "Unknown OS";

		if(navigator.appVersion.indexOf("Win") != -1) {
			OSName = "Windows";
		}

		if(navigator.appVersion.indexOf("Mac") != -1) {
			OSName = "MacOS"
		};

		return OSName;
	}

	getClientVersion() {
		let version = "32bit";

		if(navigator.userAgent.indexOf("WOW64") != -1 || navigator.userAgent.indexOf("Win64") != -1) {
			version = "64bit";
		}else{
			version = "32bit";
		}

		return version;
	}

	trackDownload(isWindows, is32, type) {
		if(blapp.cookie.isCookieEnabled("TGA")) {
			_paq.push(['trackEvent', 'Studio', 'Download', 'Studio Download']);
		}

		if(!isWindows) {
			blapp.track.trackGeneral(10034, "BLStudio2DownloadMac");
		}else{
			if(is32){
				blapp.track.trackGeneral(10032, "BLStudio2DownloadWin32");
			}else{
				blapp.track.trackGeneral(10033, "BLStudio2DownloadWin64");
			}
		}
	}

	trackAdCode(aoc) {
		blAjax.call("/track_ad.ajax",	{
			aoc: aoc,
			pageId: blapp.track.getPageID()
		}).then((data) => {
			//console.log(data);
		}).catch((err) => {
			//console.log(err);
		});
	}
}

document.addEventListener("DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<StudioDownload blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-studio-download' )
						);
		blapp.refs.register( "main", elem );
	}
);